export class ForgotPasswordModel{
    Email:string;
    Token: string;
    Password: string;
    UserID: number;
    ForceSendToken: boolean;
    SendToken:boolean;
    Error: string;
    OldPassword: string;
    NewPassword: string;
    ConfirmPassword: string;
    State:string;
    MobileLast4Digits:string;
    

    constructor(obj?:any){  
        this.Email = obj && obj.Email || '';
        this.Token = obj && obj.Token || '';
        this.Password = obj && obj.Password || '';
        this.UserID = obj && obj.UserID || 0;
        this.ForceSendToken = obj && obj.ForceSendToken || false;
        this.SendToken = obj && obj.SendToken || false;        
        this.Error = obj && obj.Error || '';
        this.OldPassword = obj && obj.OldPassword || '';
        this.NewPassword = obj && obj.NewPassword || '';
        this.ConfirmPassword = obj && obj.ConfirmPassword || '';
        this.State = obj && obj.State || '';
        this.MobileLast4Digits = obj && obj.MobileLast4Digits || '';
    }
}